import { useResetRecoilState } from 'recoil';
import { useFieldBase } from './useField';
// TODO: move to better location (utils?)
const isInputEvent = (event) => {
    return 'value' in event.target;
};
export function useAutocomplete(props) {
    // get base props of validation fields
    const [{ value, ...baseProps }, saveValue, invokeValidation] = useFieldBase(props);
    const resetValue = useResetRecoilState(props.atom);
    return {
        ...baseProps,
        onBlur: (event) => {
            // we trigger validation if value is empty on blur AND no new value is given
            if ((Array.isArray(value) && value.length === 0) ||
                ((value === '' || value === null) &&
                    isInputEvent(event) &&
                    !event.target.value)) {
                return invokeValidation();
            }
            if (props.freeSolo &&
                isInputEvent(event) &&
                event.target.value.length > 0) {
                saveValue(event.target.value);
            }
        },
        // triggers only when elements are selected (no freesolo input changes)
        onChange: (_e, value, reason) => {
            if (reason === 'removeOption' &&
                Array.isArray(value) &&
                value?.length === 0) {
                saveValue('');
                return;
            }
            // null indicates that we need to reset the underlying state
            if (value === null) {
                //trigger validation on clear
                if (reason === 'clear') {
                    saveValue('');
                    return;
                }
                resetValue();
                return;
            }
            saveValue(value);
        },
        value,
    };
}
export function useAutocompleteMultiple(props) {
    // get base props of validation fields
    const [{ value, ...baseProps }, saveValue, invokeValidation] = useFieldBase(props);
    return {
        ...baseProps,
        onBlur: (event) => {
            // we trigger validation if value array has no elements on blur
            if (Array.isArray(value) && value.length < 1) {
                return invokeValidation();
            }
            if (isInputEvent(event) && event.target.value.length > 0) {
                saveValue(event.target.value);
            }
        },
        onChange: (_e, value) => {
            // TODO: removed null
            if (typeof value !== 'undefined')
                saveValue(value);
        },
        value,
    };
}
